/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NoAccessComponent } from './no-access.component';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [{ path: 'no-access', component: NoAccessComponent }];

@NgModule({
  declarations: [NoAccessComponent],
  imports: [CommonModule, RouterModule.forChild(routes)],
  exports: [NoAccessComponent],
})
export class NoAccessModule {}
